import { EntityTypeEnum, Type83fEnum } from '@crm/api'
import { useLocales } from '@shared/locales'
import { Col, Form, Input, Row, Select } from 'antd'
import { FormInstance } from 'antd/lib'

import { CustomFieldsOptionsItem } from './CustomFieldsOptionsItem'
import { CustomFieldsValidationRules } from './CustomFieldsValidationRules'
import { DefaultValueFormItem } from './DefaultValueFormItem'

type Props = {
  lang: string
  form: FormInstance
  isEdit?: boolean
}

export const FormNomenclaturesCustomFields = ({
  lang,
  form,
  isEdit
}: Props) => {
  const { t } = useLocales()

  const typeOptions = Object.values(Type83fEnum).map((value) => ({
    label: t(`nomenclature.field_type.${value}`),
    value
  }))

  const entityTypeOptions = Object.values(EntityTypeEnum).map((value) => ({
    label: t(`nomenclature.entity_type.${value}`),
    value
  }))

  const type = Form.useWatch('type', form)

  const onChangeType = (value: string) => {
    form.setFieldsValue({ type: value })
    form.resetFields(['default_value', 'options', 'validation_rules'])
  }

  return (
    <Row gutter={[16, 0]}>
      <Col span={12}>
        <Form.Item
          name={`key_${lang}`}
          label={t('nomenclature.name')}
          rules={[{ required: true }]}
        >
          <Input placeholder={t('nomenclature.name')} />
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item
          name="entity_type"
          label={t('nomenclature.entity_type.title')}
          rules={[{ required: true }]}
        >
          <Select
            disabled={isEdit}
            options={entityTypeOptions}
            placeholder={t('nomenclature.entity_type.title')}
          />
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item
          name="type"
          label={t('nomenclature.type')}
          rules={[{ required: true }]}
        >
          <Select
            disabled={isEdit}
            options={typeOptions}
            onChange={onChangeType}
            placeholder={t('nomenclature.type')}
          />
        </Form.Item>
      </Col>

      {type && (
        <Col span={12}>
          <DefaultValueFormItem form={form} />
        </Col>
      )}

      {(type === Type83fEnum.SELECT || type === Type83fEnum.MULTISELECT) && (
        <Col span={24}>
          <CustomFieldsOptionsItem form={form} disabled={isEdit} />
        </Col>
      )}

      <CustomFieldsValidationRules disabled={isEdit} form={form} />
    </Row>
  )
}
